  <div class="manage-team-container">
    <div class="container">
<section class="content-section col-md-12">
  <h2 style="text-align:center;color:white;">Manage your team</h2>
    <table class="table table-bordered" border="0" >
      <thead>
       <tr>
        <th>No</th>
        <th>First Name</th>
        <th>Last Name</th>
        <th>Email</th>
        <th>Country</th>
        <th>Organization</th>
        <th>Username</th>
        <th>Editor</th>
        <th>Active</th>
        <th>Delete</th>
        <th>Edit</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let m of team_members; let i = index">
        <td>{{i+1}}</td>
        <td *ngIf="!edit[i]" class="inline-edit">{{m.first_name}}</td>
        <td *ngIf="edit[i]" class="inline-edit"><input type="text" [(ngModel)]="m.first_name"/></td>
        <td *ngIf="!edit[i]" class="inline-edit">{{m.last_name}}</td>
        <td *ngIf="edit[i]" class="inline-edit"><input type="text" [(ngModel)]="m.last_name"/></td>
        <td *ngIf="!edit[i]" class="inline-edit">{{m.email}}</td>
        <td *ngIf="edit[i]" class="inline-edit"><input type="text" [(ngModel)]="m.email"/></td>
        <td>{{m.team_name}}</td>
        <td *ngIf="!edit[i]" class="inline-edit">{{m.organization}}</td>
        <td *ngIf="edit[i]" class="inline-edit"><input type="text" [(ngModel)]="m.organization"/></td>
        <td *ngIf="!edit[i]" class="inline-edit">{{m.username}}</td>
        <td *ngIf="edit[i]" class="inline-edit"><input type="text" [(ngModel)]="m.username"/></td>
        <td><input type="checkbox" value="m.id" checked="m.can_edit" [(ngModel)]="m.can_edit" (change)="saveMember(i)"/></td>
        <td><input type="checkbox" value="m.id" checked="m.is_active" [(ngModel)]="m.is_active" (change)="saveMember(i)"/></td>
        <td><a (click)="deleteMember(i)" style="color:red;">Delete</a></td>
        <td *ngIf="!edit[i]"><a (click)="edit[i]=true">Edit</a></td>
        <td *ngIf="edit[i]"><a (click)="saveMember(i)">Save</a></td>
      </tr>
      </tbody>
    </table>
  </section>
    </div></div>



// WEBPACK FOOTER //
// ./src/app/manage-team/manage-team.component.html